export interface PPFRProps {
  dateFrom?: string;
  dateTo?: string;
}

export const getPPFilterRequest = (event: PPFRProps): Partial<any> => {
  return {
    ...(event?.dateFrom
      ? {
          fechaDesde: event?.dateFrom,
        }
      : {}),
    ...(event?.dateTo
      ? {
          fechaHasta: event?.dateTo,
        }
      : {}),
  };
};
